module.exports = __webpack_public_path__ + "static/media/Bicocca - white_Ind.Blue.2ed89809.jpg";